<template>
  <div @mousemove.stop style="width: 100%;height: 100%;">
  <l-map
    ref="map"
    :zoom="zoom"
    :center="center"
    :options="config.options"
    @update:center="centerUpdate"
    @update:zoom="zoomUpdate"
    class="c-map"
  >
    <l-tilelayer :url="config.url" :attribution="config.attribution" />

    <template v-for="(item, index) in routes_list">
      <!-- Маршруты -->
      <c-map-item-route 
        :key="`route-${item.id}-${index}`"
        :item="item"
        :polyline_weight="settings_ui.line_size"
      />
      <!-- Маршруты END -->

      <!-- Остановки -->
      <template v-if="item.stops">
      <!-- Прямо -->
      <c-map-item-stop
        v-for="(stop, i) in item.stops.forward"
        :key="`stops-forward-${item.id}-${i}-${index}`"
        :item="stop"
        color="#64D252"
        :icon_size="settings_ui.icon_stop_size"
      />
      <!-- Прямо END-->

      <!-- Обратно -->
      <c-map-item-stop
        v-for="(stop, i) in item.stops.backward"
        :key="`stops-backward-${item.id}-${i}-${index}`"
        :item="stop"
        color="#E6646C"
        :icon_size="settings_ui.icon_stop_size"
      />
      <!-- Обратно END-->
      <!-- Остановки END-->
      </template>
    </template>
    <!-- ТС -->
    <c-map-item-car 
      v-for="(car, i) in cars_list"
      :key="`car-${car.number}-${i}`"
      :item="car"
      :font_size="settings_ui.font_size"
      :icon_size="settings_ui.icon_car_size"
    />
    <!-- ТС END -->
  </l-map>
</div>
</template>

<script>
import * as Vue2Leaflet from 'vue2-leaflet'
import cMapItemRoute from '@/components/map/group/c-map-item-route'
import cMapItemStop from '@/components/map/group/c-map-item-stop'
import cMapItemCar from '@/components/map/group/c-map-item-car'

import { differenceTwoArrays } from '@/helpers/base'
import { config_map } from '@/config'
export default {
  name: 'c-map',
  components: {
    'l-map': Vue2Leaflet.LMap,
    'l-tilelayer': Vue2Leaflet.LTileLayer,
    cMapItemRoute,
    cMapItemStop,
    cMapItemCar
  },
  props: {
    rect_id: {
      type: [Number, String],
      default: null
    },
    routes_list: {
      type: Array,
      default() {
        return []
      }
    }, 
    cars_list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      config: config_map
    }
  },
  mounted() {
    this.$nextTick(() => this.resizeMap())
  },
  computed: {
    map_options_by_rect_id() {
      return { ...this.$store.getters.RECT_MAP_OPTIONS_BY_RECT_ID(this.rect_id) }
    },
    center() {
      return this.map_options_by_rect_id.center
    },
    zoom() {
      return this.map_options_by_rect_id.zoom
    },
    settings_ui() {
      return this.$store.getters.SETTINGS_ADAPTER_UI
    },
    rect_routes_count() {
      return this.$store.getters.RECT_ROUTES_LIST_COUNT(this.rect_id)
    }
  },
  methods: {
    resizeMap() {
      this.$refs.map.mapObject.invalidateSize()
    },
    centerUpdate(center) {
      const arrayLatLng = (val) => {
        let parse = { ...val }
        return [ parse.lat, parse.lng ]
      }
      let lat_lng = arrayLatLng(center)

      let obj = { ...this.map_options_by_rect_id }
      obj.center = [ ...lat_lng ]
      
      // Предотвращаем обновление данных, если значения одинаковые
      if(!differenceTwoArrays(this.center, lat_lng)) {
        this.$store.commit('RECT_MAP_OPTIONS_UPDATE', obj)
      }
    },
    zoomUpdate(zoom) {
      let obj = { ...this.map_options_by_rect_id }
      obj.zoom = zoom

      // Предотвращаем обновление данных, если значения одинаковые
      if(this.zoom != obj.zoom) {
        this.$store.commit('RECT_MAP_OPTIONS_UPDATE', obj)
      }
    }
  },
  watch: {
    rect_routes_count (newCount, oldCount) {
      if (newCount > oldCount) {
        let center = this.$store.getters.RECT_BY_ID(this.rect_id).center
        if (center !== undefined) {
          this.centerUpdate(center)
        }
      }
    }
  }
}
</script>

<style lang="scss">
  @import '@/assets/scss/blocks/map';
  .vue2leaflet-map {
    .leaflet-marker-icon {
      transition: all .3s;
    }
  }
</style>